import React from 'react';
import { ConfirmDeletePopup, IconButton, IconType } from 'features/nekst-widgets';
import { TasksGroup, useTasksGroupsAdminService } from 'nekst-api';
import { usePopupManager, useShowContextRequired } from 'ui-builder';

function DeleteTasksGroupAdminPopup() {
  const tasksGroupsAdminService = useTasksGroupsAdminService();
  const showContext = useShowContextRequired<TasksGroup>();

  return (
    <ConfirmDeletePopup
      deleteFunc={async () => {
        await tasksGroupsAdminService.deleteTasksGroup(showContext.data!.id);
      }}
      message={`By clicking 'Confirm', the group "${showContext.data!.name}" will be removed. All tasks within this group will be ungrouped.`}
    />
  );
}

export function DeleteTasksGroupAdminButton() {
  const popupManager = usePopupManager();

  return (
    <IconButton
      onClick={() => {
        popupManager.openPopup(<DeleteTasksGroupAdminPopup />);
      }}
      type={IconType.TRASH_CAN}
      title="Delete Tasks Group"
    />
  );
}
